export default __webpack_public_path__ + "static/media/testing.2fe1ec1b.webp";